import { lazyNamedComponent } from './utils/lazy-named-component';

export {
  ActivityDetailsView,
  Asset3d,
  AssetProperties,
  AssetTrends,
  DataModelingOverridePage,
  IdmObservationsDesktopFormPage,
  IdmObservationsDesktopTablePage,
  IdmObservationsMobileListPage,
  IdmObservationMobileOverviewPage,
  LandingPage,
  NotificationDetailsView,
  PageNotFound,
  TemplateCreatedConfirmationPage,
  TemplatesMobile,
} from './shared-lazy-route-pages';

export const ActivityListView = lazyNamedComponent(
  () => import('./activity/cdm-activity-list-view'),
  'ActivityListView'
);

export const ActivityChecklistMobile = lazyNamedComponent(
  () => import('./activity/cdm-activity-checklist-mobile'),
  'ActivityChecklistMobile'
);

export const ActivityDesktop = lazyNamedComponent(
  () => import('./activity/activity-desktop/cdm-activity-desktop'),
  'ActivityDesktop'
);

export const ActivityPlanningView = lazyNamedComponent(
  () => import('./activity/activity-planning/cdm-activity-planning-view'),
  'ActivityPlanningView'
);

export const AssetActivities = lazyNamedComponent(
  () => import('./asset/cdm-asset-activities'),
  'AssetActivities'
);

export const AssetDocuments = lazyNamedComponent(
  () => import('./asset/cdm-asset-documents'),
  'AssetDocuments'
);

export const AssetDetails = lazyNamedComponent(
  () => import('./asset/cdm-asset-details'),
  'AssetDetails'
);

export const AssetNotifications = lazyNamedComponent(
  () => import('./asset/cdm-asset-notifications'),
  'AssetNotifications'
);

export const ChecklistItemObservationFormPage = lazyNamedComponent(
  () =>
    import(
      './checklist/cdm-checklist-item-observation-form-page/cdm-checklist-item-observation-form-page'
    ),
  'ChecklistItemObservationFormPage'
);

export const ChecklistItemObservationListPage = lazyNamedComponent(
  () =>
    import(
      './checklist/cdm-checklist-item-observation-list-page/cdm-checklist-item-observation-list-page'
    ),
  'ChecklistItemObservationListPage'
);

export const PageLayout = lazyNamedComponent(
  () => import('./cdm-page-layout'),
  'PageLayout'
);

export const SchedulesPage = lazyNamedComponent(
  () => import('./schedules/cdm-schedules-page'),
  'SchedulesPage'
);

export const TemplatesOverviewNew = lazyNamedComponent(
  () => import('./template/cdm-templates-overview-new'),
  'TemplatesOverviewNew'
);

export const UserProfilePage = lazyNamedComponent(
  () => import('./user-profile-page/cdm-user-profile-page'),
  'UserProfilePage'
);
